import type { PropertyDetails } from "@/src/constants/propertyWizard";

export type RequiredWizardPropertyDetailsErrorKey =
  | "add_property_validation_address"
  | "add_property_validation_name"
  | "add_property_validation_type"
  | "add_property_validation_year";

export const WIZARD_PROPERTY_DETAILS_VALIDATION_MESSAGES: Record<
  RequiredWizardPropertyDetailsErrorKey,
  string
> = {
  add_property_validation_address: "Select an address from the Google suggestions.",
  add_property_validation_name: "Property name is required.",
  add_property_validation_type: "Property type is required.",
  add_property_validation_year: "Year built is required.",
};

export const hasSelectedGooglePlace = (details: PropertyDetails): boolean =>
  details.addressLine.trim().length > 0 &&
  typeof details.latitude === "number" &&
  Number.isFinite(details.latitude) &&
  typeof details.longitude === "number" &&
  Number.isFinite(details.longitude);

export const getRequiredWizardPropertyDetailsErrorKey = (
  details: PropertyDetails,
  options?: { allowManualAddress?: boolean },
): RequiredWizardPropertyDetailsErrorKey | null => {
  const allowManual = options?.allowManualAddress === true;
  if (allowManual) {
    if (
      !details.addressLine.trim() ||
      !details.city.trim() ||
      !details.state.trim() ||
      !details.zipCode.trim()
    ) {
      return "add_property_validation_address";
    }
  } else if (!hasSelectedGooglePlace(details)) {
    return "add_property_validation_address";
  }
  if (!details.name.trim()) {
    return "add_property_validation_name";
  }
  if (!details.type.trim()) {
    return "add_property_validation_type";
  }
  if (!details.yearBuilt.trim()) {
    return "add_property_validation_year";
  }
  return null;
};
